var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5463,
    height: 3011,
    viewBox: "0 0 5463 3011",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49_663)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5463,
    height: 3011,
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_49_663)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1235.85 3.78826L1233.2 0.449219L-1151.09 3005.59L-1148.44 3008.93L1235.85 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1505.6 3.78826L1502.95 0.449219L-881.34 3005.59L-878.69 3008.93L1505.6 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1775.35 3.78826L1772.7 0.449219L-611.588 3005.59L-608.937 3008.93L1775.35 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2045.1 3.78826L2042.45 0.449219L-341.839 3005.59L-339.188 3008.93L2045.1 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2314.85 3.78826L2312.21 0.449219L-72.084 3005.59L-69.4364 3008.93L2314.85 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2584.61 3.78826L2581.96 0.449219L197.67 3005.59L200.317 3008.93L2584.61 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2854.36 3.78826L2851.72 0.449219L467.417 3005.59L470.064 3008.93L2854.36 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3124.11 3.78826L3121.46 0.449219L737.168 3005.59L739.816 3008.93L3124.11 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3393.85 3.78826L3391.2 0.449219L1006.93 3005.59L1009.57 3008.93L3393.85 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3663.63 3.78826L3660.98 0.449219L1276.67 3005.59L1279.32 3008.93L3663.63 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3933.34 3.78826L3930.69 0.449219L1546.41 3005.59L1549.05 3008.93L3933.34 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4203.12 3.78826L4200.47 0.449219L1816.16 3005.59L1818.81 3008.93L4203.12 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4472.86 3.78826L4470.21 0.449219L2085.91 3005.59L2088.56 3008.93L4472.86 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4742.6 3.78826L4739.95 0.449219L2355.66 3005.59L2358.31 3008.93L4742.6 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5012.35 3.78826L5009.7 0.449219L2625.42 3005.59L2628.06 3008.93L5012.35 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5282.09 3.78826L5279.44 0.449219L2895.17 3005.59L2897.82 3008.93L5282.09 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5551.87 3.78826L5549.22 0.449219L3164.92 3005.59L3167.56 3008.93L5551.87 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5821.61 3.78826L5818.96 0.449219L3434.66 3005.59L3437.31 3008.93L5821.61 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6091.36 3.78826L6088.71 0.449219L3704.44 3005.59L3707.09 3008.93L6091.36 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6361.1 3.78826L6358.45 0.449219L3974.18 3005.59L3976.83 3008.93L6361.1 3.78826Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1148.44 0.449707L-1151.09 3.78877L1232.99 3008.95L1235.64 3005.61L-1148.44 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-878.691 0.449707L-881.341 3.78875L1502.95 3008.93L1505.6 3005.59L-878.691 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-608.937 0.449707L-611.588 3.78875L1772.7 3008.93L1775.35 3005.59L-608.937 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-339.188 0.449707L-341.839 3.78875L2042.45 3008.93L2045.1 3005.59L-339.188 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-69.4364 0.449707L-72.084 3.78875L2312.21 3008.93L2314.85 3005.59L-69.4364 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.315 0.449707L197.667 3.78875L2581.96 3008.93L2584.61 3005.59L200.315 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.064 0.449707L467.417 3.78875L2851.72 3008.93L2854.36 3005.59L470.064 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.819 0.449707L737.168 3.78875L3121.46 3008.93L3124.11 3005.59L739.819 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.57 0.449707L1006.92 3.78875L3391.2 3008.93L3393.85 3005.59L1009.57 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.32 0.449707L1276.67 3.78875L3660.98 3008.93L3663.63 3005.59L1279.32 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1549.07 0.449707L1546.42 3.78875L3930.73 3008.93L3933.37 3005.59L1549.07 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1818.83 0.449707L1816.18 3.78875L4200.47 3008.93L4203.12 3005.59L1818.83 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2088.57 0.449707L2085.92 3.78875L4470.21 3008.93L4472.86 3005.59L2088.57 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2358.33 0.449707L2355.68 3.78875L4739.95 3008.93L4742.6 3005.59L2358.33 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2628.08 0.449707L2625.43 3.78875L5009.73 3008.93L5012.38 3005.59L2628.08 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2897.82 0.449707L2895.17 3.78875L5279.48 3008.93L5282.13 3005.59L2897.82 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3167.6 0.449707L3164.92 3.78875L5549.22 3008.93L5551.87 3005.59L3167.6 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3437.34 0.449707L3434.7 3.78875L5818.96 3008.93L5821.61 3005.59L3437.34 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3707.09 0.449707L3704.44 3.78875L6088.75 3008.93L6091.39 3005.59L3707.09 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3976.83 0.449707L3974.18 3.78875L6358.49 3008.93L6361.14 3005.59L3976.83 0.449707Z",
    fill: "black",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M2788.22 152.425C2776.57 151.41 2766.38 160.608 2765.48 172.969L2765.48 173.003C2764.58 185.364 2773.27 196.172 2784.92 197.187L2784.95 197.189C2796.61 198.204 2806.79 189.04 2807.69 176.679L2807.7 176.645C2808.6 164.284 2799.91 153.443 2788.25 152.428L2788.22 152.425Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3315.9 198.37C3304.24 197.356 3294.06 206.553 3293.16 218.915L3293.16 218.948C3292.25 231.31 3300.94 242.117 3312.6 243.132L3312.63 243.135C3324.29 244.15 3334.47 234.985 3335.37 222.624V222.59C3336.27 210.229 3327.59 199.388 3315.93 198.373L3315.9 198.37Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3843.58 244.317C3831.92 243.302 3821.74 252.5 3820.84 264.861V264.895C3819.93 277.256 3828.62 288.063 3840.28 289.078L3840.31 289.081C3851.97 290.096 3862.15 280.932 3863.05 268.571L3863.05 268.537C3863.95 256.176 3855.27 245.335 3843.61 244.32L3843.58 244.317Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4371.26 290.263C4359.6 289.247 4349.42 298.446 4348.51 310.807V310.84C4347.61 323.202 4356.3 334.009 4367.96 335.024L4367.99 335.027C4379.64 336.042 4389.82 326.877 4390.72 314.516L4390.73 314.483C4391.63 302.121 4382.94 291.28 4371.28 290.265L4371.26 290.263Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4898.93 336.208C4887.27 335.193 4877.09 344.391 4876.19 356.752V356.786C4875.28 369.147 4883.97 379.954 4895.63 380.969L4895.66 380.972C4907.32 381.987 4917.5 372.823 4918.4 360.462L4918.4 360.428C4919.31 348.067 4910.62 337.226 4898.96 336.211L4898.93 336.208Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5426.61 382.154C5414.95 381.139 5404.77 390.337 5403.87 402.698L5403.86 402.732C5402.96 415.093 5411.65 425.901 5423.31 426.916L5423.34 426.918C5435 427.933 5445.18 418.769 5446.08 406.408V406.374C5446.99 394.013 5438.3 383.172 5426.64 382.157L5426.61 382.154Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2747.37 711.976C2735.71 710.961 2725.53 720.161 2724.63 732.522L2724.63 732.554C2723.73 744.915 2732.41 755.724 2744.07 756.74H2744.1C2755.76 757.755 2765.94 748.592 2766.84 736.231L2766.84 736.194C2767.75 723.834 2759.06 712.996 2747.4 711.981L2747.37 711.976Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3275.05 757.923C3263.39 756.908 3253.21 766.104 3252.3 778.468V778.501C3251.4 790.862 3260.09 801.671 3271.75 802.682L3271.78 802.686C3283.44 803.702 3293.61 794.538 3294.52 782.178L3294.52 782.141C3295.42 769.78 3286.74 758.938 3275.08 757.927L3275.05 757.923Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3802.73 803.869C3791.07 802.854 3780.89 812.054 3779.98 824.415L3779.98 824.447C3779.08 836.808 3787.77 847.617 3799.43 848.632H3799.46C3811.12 849.648 3821.29 840.485 3822.2 828.124L3822.2 828.087C3823.1 815.726 3814.41 804.889 3802.76 803.873L3802.73 803.869Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4330.4 849.816C4318.75 848.8 4308.56 857.996 4307.66 870.357L4307.66 870.394C4306.75 882.754 4315.44 893.559 4327.1 894.575L4327.13 894.579C4338.79 895.594 4348.97 886.427 4349.87 874.066L4349.88 874.034C4350.78 861.673 4342.09 850.831 4330.43 849.816H4330.4Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4858.08 895.762C4846.42 894.747 4836.24 903.943 4835.34 916.303V916.336C4834.43 928.701 4843.12 939.506 4854.78 940.521L4854.81 940.525C4866.47 941.541 4876.65 932.373 4877.55 920.013L4877.55 919.98C4878.45 907.619 4869.77 896.778 4858.11 895.762H4858.08Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5385.75 941.704C5374.1 940.693 5363.91 949.889 5363.01 962.249L5363.01 962.282C5362.11 974.647 5370.8 985.452 5382.45 986.467L5382.48 986.471C5394.14 987.487 5404.32 978.32 5405.22 965.959L5405.23 965.926C5406.13 953.565 5397.44 942.724 5385.79 941.708L5385.75 941.704Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2706.52 1271.53C2694.86 1270.51 2684.68 1279.71 2683.78 1292.07L2683.78 1292.11C2682.87 1304.47 2691.56 1315.27 2703.22 1316.29L2703.25 1316.29C2714.91 1317.31 2725.09 1308.14 2725.99 1295.78L2725.99 1295.75C2726.89 1283.39 2718.21 1272.54 2706.55 1271.53H2706.52Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3234.19 1317.47C3222.54 1316.46 3212.36 1325.66 3211.45 1338.02L3211.45 1338.05C3210.55 1350.41 3219.24 1361.22 3230.9 1362.23H3230.93C3242.59 1363.25 3252.76 1354.09 3253.67 1341.73L3253.67 1341.69C3254.57 1329.33 3245.89 1318.49 3234.23 1317.48L3234.19 1317.47Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3761.87 1363.42C3750.21 1362.4 3740.04 1371.6 3739.13 1383.96L3739.13 1384C3738.23 1396.36 3746.92 1407.17 3758.57 1408.18L3758.61 1408.19C3770.26 1409.2 3780.44 1400.03 3781.34 1387.67L3781.35 1387.64C3782.25 1375.28 3773.56 1364.44 3761.91 1363.42L3761.87 1363.42Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4289.55 1409.36C4277.89 1408.35 4267.71 1417.55 4266.81 1429.91L4266.81 1429.94C4265.9 1442.3 4274.59 1453.11 4286.25 1454.13H4286.28C4297.94 1455.14 4308.12 1445.98 4309.02 1433.62V1433.59C4309.92 1421.22 4301.24 1410.38 4289.58 1409.37L4289.55 1409.36Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4817.23 1455.31C4805.57 1454.3 4795.39 1463.5 4794.49 1475.86L4794.48 1475.89C4793.58 1488.25 4802.27 1499.06 4813.92 1500.07H4813.96C4825.62 1501.09 4835.8 1491.93 4836.7 1479.57L4836.7 1479.53C4837.6 1467.17 4828.91 1456.33 4817.26 1455.31L4817.23 1455.31Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5344.9 1501.26C5333.25 1500.24 5323.06 1509.44 5322.16 1521.8L5322.16 1521.84C5321.26 1534.2 5329.95 1545 5341.6 1546.02H5341.63C5353.29 1547.04 5363.47 1537.87 5364.37 1525.51V1525.48C5365.28 1513.11 5356.59 1502.28 5344.93 1501.26L5344.9 1501.26Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2665.67 1831.08C2654.01 1830.06 2643.83 1839.26 2642.93 1851.62L2642.92 1851.66C2642.02 1864.02 2650.71 1874.83 2662.37 1875.84L2662.4 1875.85C2674.06 1876.86 2684.23 1867.69 2685.14 1855.33L2685.14 1855.3C2686.04 1842.94 2677.36 1832.1 2665.7 1831.08L2665.67 1831.08Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3193.34 1877.02C3181.69 1876.01 3171.51 1885.21 3170.6 1897.57L3170.6 1897.6C3169.7 1909.96 3178.39 1920.77 3190.04 1921.79H3190.07C3201.73 1922.8 3211.91 1913.64 3212.82 1901.28V1901.25C3213.72 1888.89 3205.03 1878.04 3193.38 1877.03L3193.34 1877.02Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3721.02 1922.97C3709.36 1921.96 3699.18 1931.16 3698.28 1943.52V1943.55C3697.38 1955.91 3706.06 1966.72 3717.72 1967.73H3717.75C3729.41 1968.75 3739.59 1959.59 3740.49 1947.23L3740.5 1947.19C3741.4 1934.83 3732.71 1923.99 3721.05 1922.97L3721.02 1922.97Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4248.7 1968.92C4237.04 1967.9 4226.86 1977.1 4225.95 1989.46V1989.5C4225.05 2001.86 4233.74 2012.66 4245.4 2013.68L4245.43 2013.68C4257.09 2014.7 4267.26 2005.53 4268.17 1993.17L4268.17 1993.14C4269.07 1980.77 4260.39 1969.93 4248.73 1968.92H4248.7Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4776.37 2014.86C4764.72 2013.85 4754.53 2023.04 4753.63 2035.4V2035.44C4752.73 2047.8 4761.41 2058.61 4773.07 2059.62L4773.11 2059.63C4784.76 2060.64 4794.94 2051.47 4795.84 2039.11L4795.85 2039.08C4796.75 2026.72 4788.06 2015.88 4776.4 2014.86H4776.37Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5304.05 2060.81C5292.4 2059.79 5282.21 2068.99 5281.31 2081.36L5281.31 2081.39C5280.4 2093.75 5289.09 2104.55 5300.75 2105.57L5300.78 2105.57C5312.44 2106.59 5322.62 2097.43 5323.52 2085.06V2085.03C5324.43 2072.67 5315.74 2061.83 5304.08 2060.81H5304.05Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2624.81 2390.63C2613.16 2389.62 2602.98 2398.82 2602.07 2411.18L2602.07 2411.21C2601.17 2423.57 2609.86 2434.38 2621.51 2435.39L2621.55 2435.4C2633.2 2436.41 2643.38 2427.25 2644.28 2414.89L2644.29 2414.85C2645.19 2402.49 2636.5 2391.65 2624.85 2390.64L2624.81 2390.63Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3152.49 2436.58C3140.83 2435.57 3130.65 2444.76 3129.75 2457.12V2457.16C3128.85 2469.52 3137.54 2480.32 3149.19 2481.34L3149.22 2481.34C3160.88 2482.36 3171.06 2473.2 3171.96 2460.83L3171.96 2460.8C3172.87 2448.44 3164.18 2437.6 3152.52 2436.58H3152.49Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3680.17 2482.52C3668.51 2481.51 3658.33 2490.71 3657.43 2503.07L3657.42 2503.1C3656.52 2515.46 3665.21 2526.27 3676.87 2527.29L3676.9 2527.29C3688.56 2528.31 3698.74 2519.14 3699.64 2506.78V2506.75C3700.54 2494.39 3691.86 2483.54 3680.2 2482.53L3680.17 2482.52Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4207.84 2528.47C4196.19 2527.45 4186.01 2536.65 4185.1 2549.01V2549.04C4184.2 2561.41 4192.89 2572.21 4204.55 2573.23L4204.58 2573.23C4216.24 2574.25 4226.41 2565.08 4227.32 2552.72L4227.32 2552.69C4228.22 2540.33 4219.54 2529.49 4207.88 2528.47L4207.84 2528.47Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4735.52 2574.42C4723.86 2573.41 4713.68 2582.6 4712.78 2594.96L4712.78 2594.99C4711.87 2607.36 4720.56 2618.16 4732.22 2619.18L4732.25 2619.18C4743.91 2620.2 4754.09 2611.03 4754.99 2598.67V2598.64C4755.89 2586.28 4747.21 2575.44 4735.55 2574.42L4735.52 2574.42Z",
    fill: "black",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5263.2 2620.36C5251.54 2619.35 5241.36 2628.54 5240.46 2640.91L5240.46 2640.94C5239.55 2653.3 5248.24 2664.11 5259.9 2665.12L5259.93 2665.13C5271.59 2666.14 5281.77 2656.98 5282.67 2644.61V2644.58C5283.57 2632.22 5274.89 2621.38 5263.23 2620.36H5263.2Z",
    fill: "black",
    fillOpacity: 0.13
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49_663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5463,
    height: 3011,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_49_663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6362,
    height: 3011,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.213c5359b1ef11e49871b09c9a1cf8a0.svg";
export { ForwardRef as ReactComponent };